import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=fa2f815e&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa2f815e')) {
      api.createRecord('fa2f815e', component.options)
    } else {
      api.reload('fa2f815e', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=fa2f815e&", function () {
      api.rerender('fa2f815e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F49R00KfE3Gz/JS/comp/FavElement.vue"
export default component.exports